import MessageHub from './signalr/SignalrMessageHub';
import connector from './Connector';
class RealtimeSubscriptionManager {
  subscriptions = [];

  constructor() {
    connector.subscribe('socketClosed', () => this.recall(this.subscriptions));
  }

  subscribe(channel) {
    if (!this.subscriptions[channel]) {
      this.subscriptions[channel] = 1;
    } else {
      this.subscriptions[channel]++;
    }
    MessageHub.subscribe(channel);
  }

  unsubscribe(channel) {
    if (this.subscriptions[channel] < 1) {
      MessageHub.unsubscribe(channel);
    }
    if (this.subscriptions[channel]) {
      this.subscriptions[channel]--;
    }
  }

  recall(subscriptions) {
    for (var key in subscriptions) {
      MessageHub.subscribe(key);
    }
  }
}

var realtimeSubscriptionManager = new RealtimeSubscriptionManager();

export default realtimeSubscriptionManager;
